import React, { useEffect, useState } from "react";
import { Col, Container, Nav, Row, Tab } from "react-bootstrap";
import AreaChart from "../../../components/Graph/AreaChart";
import {
  capitalizedFirstAlphaBet,
  catchAsync,
  checkResponse,
} from "../../../utilities/utilities";
import {
  GET_EARNING_REPORT,
  SERVICE_CATEGORY_LIST,
  SERVICE_PROVIDERS_LIST,
} from "../../../services/ApiCalls";
import Loader from "../../../components/Common/Loader";
import {
  earningTabArr,
  earningTypeOptions,
  userTypeOptions,
} from "../../../utilities/const";
import TableLayout from "../../../components/TableLayout";
import Filter from "../../../components/Common/Filter";

const Earnings = () => {
  const [data, setData] = useState();
  const [loader, setLoader] = useState(false);
  const [body, setBody] = useState({ groupBy: "week", filter: "all" });
  const [atbText, setatbText] = useState("weekly");
  const [displayValue, setdisplayValue] = useState("dayOfWeek");
  const getData = catchAsync(async () => {
    setLoader(true);
    const res = await GET_EARNING_REPORT({ ...body });
    checkResponse({ res, setData, setLoader });
  }, setLoader);

  const [revenueView, setRevenueView] = useState({
    list: true,
    graph: false,
  });
  const [tableDisplayValue, setTableDisplayValue] = useState("Days Of Week");
  const [tableData, setTableData] = useState([]);
  // useEffect(() => {
  // 	getData();
  // }, []);

  const [searchFilterOptionArr, setSearchFilterOptionArr] = useState([]);

  useEffect(() => {
    switch (body?.groupBy) {
      case "week":
        setatbText("Current Week");
        setdisplayValue("dayOfWeek");
        setTableDisplayValue("Days Of Week");

        break;
      case "month":
        setatbText("Current Month");
        setdisplayValue("date");
        setTableDisplayValue("Dates");

        break;
      case "year":
        setatbText("Current Year");
        setdisplayValue("month");
        setTableDisplayValue("Months");

        break;
      default:
        setatbText("Current Week");
        setdisplayValue("dayOfWeek");
        setTableDisplayValue("Days Of Week");
        break;
    }
    getData();
  }, [body]);

  const column = [
    {
      head: tableDisplayValue,
      accessor: "tableDisplayValue",
    },
    {
      head: "Gross Revenue",
      accessor: "revenueTotal",
    },
    {
      head: "Therapist Payouts",
      accessor: "expertPayoutTotal",
    },
    {
      head: "Service Revenue",
      accessor: "serviceRevenueTotal",
    },
  ];

  useEffect(() => {
    let tableDatas = [];
    // console.log("displayValue", displayValue)
    if (data?.byOrder?.length) {
      data.byOrder.forEach((item) => {
        // Use a fallback for dayOfWeek if it’s null
        if (displayValue) {
          tableDatas.push({
            tableDisplayValue: item[displayValue],
            revenueTotal: item.revenueTotal || 0,
            expertPayoutTotal: item.expertPayoutTotal || 0,
            serviceRevenueTotal: item.serviceRevenueTotal || 0,
          });
        } else {
          tableDatas.push({
            tableDisplayValue: item.dayOfWeek || item.date,
            revenueTotal: item.revenueTotal || 0,
            expertPayoutTotal: item.expertPayoutTotal || 0,
            serviceRevenueTotal: item.serviceRevenueTotal || 0,
          });
        }
      });
    }

    setTableData(tableDatas);
  }, [data, displayValue]);

  // console.log("body",body)

  useEffect(() => {
    setLoader(true);
    let getDataN = catchAsync(async () => {
      if (body?.filter === "category") {
        const res = await SERVICE_CATEGORY_LIST({ status: "active" });
        var newData = res?.data?.data?.map((da) => {
          return { label: da?.catName, value: da?._id };
        });
      } else {
        const res = await SERVICE_PROVIDERS_LIST({
          status: "approved",
          type: "registered",
        });
        var newData = res?.data?.data?.map((da) => {
          return { label: da?.name, value: da?._id };
        });
      }
      setSearchFilterOptionArr(newData);
    });
    getDataN();
  }, [body?.filter]);
  return (
    <>
      {loader && <Loader />}
      <section className="earningSec py-3 position-relative">
        <Container>
          <Row className="justify-content-center">
            <Col lg="12">
              <h4 className="mb-0 py-3 fw-bold themeBlue text-capitalize">
                Earning Reports
              </h4>
            </Col>
            <Col lg="12" className="my-2">
              <div className="tableFilter d-flex align-items-center justify-content-between flex-wrap gap-10 mb-3">
                <div className="left">
                  <Tab.Container
                    id="left-tabs-example"
                    defaultActiveKey="week"
                    onSelect={(selectedKey) =>
                      setBody((p) => ({
                        ...p,
                        groupBy: selectedKey,
                      }))
                    }
                  >
                    <Nav
                      variant="pills"
                      className="inline-flex rounded-pill pillsTab"
                      style={{ background: "#1C2E4F", maxWidth: "max-content" }}
                    >
                      {earningTabArr.map((item) => (
                        <Nav.Item key={item}>
                          <Nav.Link
                            className="rounded-pill d-flex align-items-center justify-content-center position-relative"
                            eventKey={item}
                          >
                            {capitalizedFirstAlphaBet(item)}
                          </Nav.Link>
                        </Nav.Item>
                      ))}
                    </Nav>
                  </Tab.Container>
                </div>
                {/* <div className="right">
                  <Filter
                    body={body}
                    setBody={setBody}
                    // searchHandler={searchHandler}
                    statusFilterOptionArr={earningTypeOptions}
                    bytext={" "}
                    filterType="filter"
                    searchFilterOptionArr={searchFilterOptionArr}
                  />
                </div> */}
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <div className="cardCstm p-3 border h-100 rounded">
                <div className="cardHead m-0 pb-2 d-flex align-items-center justify-content-between gap-10">
                  <h6 className="m-0 fw-sbold themeClr">Earning</h6>

                  <div
                    className="d-flex"
                    style={{ alignItems: "center", gap: "10px" }}
                  >
                    <p class="m-0 fw-sbold text-muted">{atbText}</p>
                    {/* <span onClick={() => setRevenueView({ list: true, graph: false })} style={{ cursor: "pointer" }}>
											<svg fill="#000000" width="24px" height="24px" viewBox="0 0 52 52" data-name="Layer 1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"><path d="M50,15.52H2a2,2,0,0,1-2-2V2A2,2,0,0,1,2,0H50a2,2,0,0,1,2,2V13.52A2,2,0,0,1,50,15.52Zm-46-4H48V4H4Z" /><path d="M50,33.76H2a2,2,0,0,1-2-2V20.24a2,2,0,0,1,2-2H50a2,2,0,0,1,2,2V31.76A2,2,0,0,1,50,33.76Zm-46-4H48V22.24H4Z" /><path d="M50,52H2a2,2,0,0,1-2-2V38.48a2,2,0,0,1,2-2H50a2,2,0,0,1,2,2V50A2,2,0,0,1,50,52ZM4,48H48V40.48H4Z" /></svg>
										</span>
									
										<div className="w-px bg-gray-300"></div>
										<span onClick={() => setRevenueView({ list: false, graph: true })} style={{ cursor: "pointer" }}>
											<svg fill="#000000" height="24px" width="24px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60">
												<g>
													<path d="M59,54.878h-1v-14H46v14h-3v-23H31v23h-3v-31H16v31h-3v-39H1v39c-0.552,0-1,0.447-1,1s0.448,1,1,1h12h3h12h3h12h3h12h1
										c0.552,0,1-0.447,1-1S59.552,54.878,59,54.878z M3,54.878v-37h8v37H3z M18,54.878v-29h8v29H18z M33,54.878v-21h8v21H33z M48,54.878
										v-12h8v12H48z" />
													<path d="M11.781,4.989l36.269,20.94l-5.457,0.529c-0.549,0.053-0.952,0.542-0.898,1.092c0.05,0.517,0.485,0.903,0.994,0.903
										c0.032,0,0.064-0.002,0.098-0.005l8.563-0.83c0.016-0.001,0.029-0.011,0.044-0.014c0.079-0.011,0.155-0.032,0.23-0.062
										c0.014-0.006,0.029-0.003,0.043-0.009c0.01-0.005,0.016-0.014,0.026-0.019c0.003-0.001,0.006-0.002,0.009-0.004
										c0.011-0.006,0.024-0.008,0.035-0.014c0.087-0.048,0.166-0.111,0.236-0.185c0.011-0.012,0.021-0.024,0.032-0.037
										c0.018-0.02,0.03-0.042,0.046-0.064c0.022-0.03,0.05-0.056,0.069-0.089c0.014-0.024,0.014-0.051,0.026-0.076
										c0.016-0.034,0.037-0.065,0.049-0.101c0.013-0.037,0.014-0.075,0.023-0.114c0.012-0.055,0.021-0.107,0.024-0.162
										c0.002-0.038,0.007-0.073,0.004-0.111c-0.001-0.012,0.005-0.022,0.003-0.034c-0.003-0.028-0.018-0.05-0.023-0.077
										c-0.01-0.056-0.024-0.109-0.044-0.162c-0.009-0.026-0.007-0.052-0.018-0.078l-3.563-7.83c-0.229-0.503-0.822-0.728-1.324-0.496
										c-0.503,0.229-0.725,0.821-0.496,1.324l2.27,4.99L12.781,3.256c-0.48-0.276-1.09-0.111-1.366,0.366
										C11.139,4.101,11.303,4.713,11.781,4.989z" />
												</g>
											</svg>
										</span> */}

                    <Nav
                      variant="pills"
                      className="inline-flex rounded-pill pillsTab"
                      style={{ background: "#1C2E4F", maxWidth: "max-content" }}
                    >
                      {["list", "graph"].map((item) => (
                        <Nav.Item key={item}>
                          <Nav.Link
                            className={`rounded-pill d-flex align-items-center justify-content-center position-relative ${
                              revenueView.list && item === "list"
                                ? "active"
                                : ""
                            }`}
                            eventKey={item}
                            onClick={() => {
                              {
                                item === "list"
                                  ? setRevenueView({ list: true, graph: false })
                                  : setRevenueView({
                                      list: false,
                                      graph: true,
                                    });
                              }
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            {capitalizedFirstAlphaBet(item)}
                          </Nav.Link>
                        </Nav.Item>
                      ))}
                    </Nav>
                  </div>
                </div>
                {revenueView.list && (
                  <div className="cardBody">
                    <TableLayout data={tableData} column={column} />
                  </div>
                )}
                {revenueView.graph && (
                  <div className="cardBody">
                    <AreaChart
                      dashboardData={data}
                      displayValue={displayValue}
                    />
                  </div>
                )}
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Earnings;
